export default __webpack_public_path__ + "static/media/Proxy-Delhaize-Grande-Haie-17.285532ed.jpg";